import React from "react";
import { toAbsoluteUrl } from "../../helpers/Reusable";
import { Link, useLocation } from "react-router-dom";

const ForgotConfirm = () => {
  const location = useLocation();
  const { userId, email } = location.state || "";

  const maskEmail = (email) => {
    if (!email) return "";
    const [name, domain] = email.split("@");
    if (domain !== "gmail.com") return email; // Only mask Gmail emails

    const maskedName = name.slice(0, 4) + "*".repeat(name.length - 6);
    return `${maskedName}@${domain}`;
  };

  return (
    <>
      <div className="w-full p-[5%] bg-yellow min-h-screen h-full">
        <div className="xxl:container mx-auto">
          <div className="flex justify-center items-center mb-[3rem] w-full">
            <img
              className="mx-auto"
              src={toAbsoluteUrl("media/img/logo/main-logo.svg")}
              alt=""
            />
          </div>
          <p className="text-center font-bold mb-[3rem] auth-text-b-lg">
            Greetings From GCC Law Help.
          </p>
          <p className="text-center font-bold mb-[3rem] auth-text-b-lg">
            Your id is {email ? maskEmail(email) : "not provided"}
          </p>
          <p className="text-center font-bold mb-[3rem] auth-text-b-lg">
            If you forgotten your password, click the link to reset it.
          </p>
          <p className="text-center font-bold mb-[3rem] auth-text-b-lg">
            We look forward to seeing you soon.
          </p>
          <div className="w-full text-center mb-[3rem]">
            <Link
              to="/forgotpassword"
              className="font-bold underline  auth-text-b-lg"
            >
              Forgot password
            </Link>
          </div>
          <p className="text-center font-bold  mb-[3rem] auth-text-b-lg">
            Thank you.
          </p>
          <p className="text-center font-bold mb-[3rem] auth-text-y-lg">
            Best Regards, <br />
            GCC Law Help
          </p>
        </div>
      </div>
    </>
  );
};

export default ForgotConfirm;
